import { populateTemplate } from '../utils/utils.js';

class FileInput extends HTMLElement {
    constructor() {
        super();
        this.files = [];
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.imageTemplate = this.querySelector('[data-image-template]');
        if (!this.imageTemplate) throw new Error("Couldn't find image template", this);

        this.imageContainer = this.querySelector('[data-image-container]');
        if (!this.imageContainer) throw new Error("Couldn't find image container", this);

        this.fileInput = this.querySelector('input[type="file"]');
        if (!this.fileInput) throw new Error("Couldn't find file input", this);

        this.addEventListeners();
    }

    addEventListeners() {
        this.inputHandler = this.handleInputChange.bind(this);
        this.removeClickHandler = this.handleRemoveClick.bind(this);

        this.fileInput.addEventListener('change', this.inputHandler);
        this.imageContainer.addEventListener('click', this.removeClickHandler);

        this.form = this.closest('form');

        if (this.form) {
            console.log('found form, adding listener');
            this.resetHandler = this.handleFormReset.bind(this);

            this.form.addEventListener('reset', this.resetHandler);
        }
    }

    handleFormReset() {
        this.fileInput.value = '';
        this.imageContainer.innerHTML = '';
    }

    handleInputChange(evt) {
        this.mergeFiles();
        this.generateImagePreviews();
    }

    mergeFiles() {
        const newFiles = Array.from(this.fileInput.files);
        /* console.log({ newFiles, oldFiles: this.files }); */
        this.files = this.files.concat(newFiles);

        const dt = new DataTransfer();

        this.files.forEach((file) => dt.items.add(file));

        this.fileInput.files = dt.files;
    }

    handleRemoveClick(evt) {
        const removeButton = evt.target.closest('[data-remove-image]');
        if (removeButton) {
            evt.stopPropagation();
            const fileName = removeButton.dataset.removeImage;
            this.removeFile(fileName);
            this.generateImagePreviews();
        }
    }

    removeFile(name) {
        const dt = new DataTransfer();

        this.files = this.files.filter((file) => file.name !== name);

        this.files.forEach((file) => {
            dt.items.add(file);
        });

        this.fileInput.files = dt.files;
    }

    async generateImagePreviews() {
        /* console.log('generateImagePreviews with files:', this.files); */
        const imagesData = await Promise.all(
            this.files.map(async (file) => {
                const image_source = await this.readFileAsync(file);
                const name = file.name;

                return { image_source, name };
            })
        );

        this.imageContainer.innerHTML = '';

        if (imagesData.length > 0) {
            this.imageContainer.classList.remove('hidden');
            imagesData.forEach((imageData) => {
                const imageEl = this.createImage(imageData);
                this.imageContainer.appendChild(imageEl);
            });
        } else {
            this.imageContainer.classList.add('hidden');
        }
    }

    async readFileAsync(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.onerror = (e) => reject(e);
            reader.readAsDataURL(file);
        });
    }

    createImage(imageData) {
        return populateTemplate(this.imageTemplate, imageData);
    }
}

customElements.define('file-input', FileInput);
